import { MapID } from "config/enums/mapIDs";

import Basic from "./basic.png";
import BubbleWrap from "./bubbleWrap.png";
import Cinnabar from "./cinnabar.png";
import Refill from "./refill.png";
import Street from "./street.png";
import Topo from "./topo.png";
import Tron from "./tron.png";
import Walkabout from "./walkabout.png";
import Outdoors from "./outdoors.png";

export const TRANSIT_OVERLAY_PREVIEWS = {
  [MapID.basic]: Basic,
  [MapID.bubbleWrap]: BubbleWrap,
  [MapID.cinnabar]: Cinnabar,
  [MapID.refill]: Refill,
  [MapID.street]: Street,
  [MapID.topo]: Topo,
  [MapID.tron]: Tron,
  [MapID.walkabout]: Walkabout,
  [MapID.outdoors]: Outdoors,
};
